import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "storefront-architecture"
    }}>{`Storefront architecture`}</h1>
    <p>{`Unlike an Adobe Commerce or Magento Open Source theme, which is dependent on the core application, a PWA Studio storefront exists on a different application layer from the core application.
The storefront still communicates with the backend application, but it is not tightly coupled with it.`}</p>
    <h2 {...{
      "id": "headless-architecture-overview"
    }}>{`Headless architecture overview`}</h2>
    <p>{`Headless architecture refers to the idea of separating the presentation layer from the data and business logic layer.
Decoupling these two layers give merchants the ability to make changes to the frontend without modifying code for the backend services.`}</p>
    <p>{`In the context of PWA Studio, the storefront is the frontend application and the Adobe Commerce or Magento Open Source application is the connected backend service.
A PWA Studio storefront does not use any of the backend application's frontend theme assets, layout files, or scripts.
Instead, it defines its own frontend files and uses the backend application's GraphQL and REST services to send or request data.`}</p>
    <p>{`For more information about headless eCommerce, read the blog post titled `}<a parentName="p" {...{
        "href": "https://magento.com/blog/best-practices/future-headless"
      }}>{`The Future Is Headless`}</a>{`.`}</p>
    <h2 {...{
      "id": "microservices"
    }}>{`Microservices`}</h2>
    <p>{`Microservice architecture is a design pattern that separates an application into independent, deployable services.
Each independent service communicates with the others through lightweight APIs.
This is known as `}<strong parentName="p">{`service isolation`}</strong>{`.`}</p>
    <p>{`Adobe Commerce and Magento Open Source services, such as those for customers, product catalog, and checkout, provide an API through `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/service-contracts/"
      }}>{`service contracts`}</a>{`.
PWA Studio storefronts interact with these services through `}<a parentName="p" {...{
        "href": "https://github.com/magento/graphql-ce"
      }}>{`GraphQL`}</a>{` and REST services.`}</p>
    <p>{`For more information about service isolation, see: `}<a parentName="p" {...{
        "href": "https://github.com/magento/architecture/blob/master/design-documents/service-isolation.md"
      }}>{`Service Isolation Vision`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      